module.exports = __webpack_public_path__ + "img/erjian_zhongji.bc4c958f.png";